import { QuestionTable } from './QuestionTable';
export default QuestionTable;
